// extracted by mini-css-extract-plugin
export default {"root":"Header_root__STLDI","left":"Header_left__pz9Ky","texts":"Header_texts__KJK5v","drawerbutton":"Header_drawerbutton__CLrPZ"};